<template lang="pug">
.lottery-record-container(
  :style="`padding-top: ${env.isEasyBikeApp ? '0.88rem' : '0'}`"
)
  //- 页面标题
  CommonHeader.page-header(
    v-if="env.isEasyBikeApp"
    title="0元抽免单 每天20点开奖",
    ref="header",
    left-black-when-active,
    left-black-when-inactive,
  )
    template(slot='left')
      .header-left-area
        img.title-logo(
          src="https://m.hellobike.com/resource/gallery/833/1epvz4ugqC.png"
          alt="0元抽免单 每天20点开奖"
        )
  //- 页面头部
  .lottery-record-header-bg(
    :class="{ 'not-app-bg': !env.isEasyBikeApp }"
  )
    img.bg-logo(
      src="https://m.hellobike.com/resource/gallery/833/6H-VaitB_Slice%2016.png"
      alt=""
    )
  //- 页面内容
  .lottery-record-content
    //- 头部内容
    LotteryRecordHeader(
      ref="recordHeaderRef"
      :marqueeList="marqueeList"
      :isProbSticky="isProbSticky"
      @showCouponLayer="handleShowCouponLayer"
    )

    //- tab列表
    .record-tab-container(ref="recordTabRef")
      .record-tab(
        :class="{ 'tab-sticky': isTabSticky }",
        :style="`top: ${tabTopValue}`"
      )
        .tab-item(
          v-for="item in tabList"
          :key="item.code"
          @click="tabClick(item)"
        )
          .name(:class="{actived: item.code == currentIndex}") {{ item.name }}
          .line(v-show="item.code == currentIndex")
    .list-page(
      v-infinite-scroll="load",
      infinite-scroll-disabled="loading",
      infinite-scroll-distance="20"
    )
      .list(v-show="userWinningList.length && currentIndex == 1")
        SuperCard(
          class="item"
          v-for="item in userWinningList"
          :dataForm="normalWinningData(item)"
          @handleClick="jumpUrl"
        )
      .list(v-show="records.length && currentIndex == 2")
        SuperCard(
          class="item"
          :layout="['activityDesc']"
          v-for="item in records"
          :dataForm="normalData(item)"
          @handleClick="jumpUrl"
        )
        .tag {{ more ? '- 滑动查看更多 -' : '- 仅展示3个月内的明细 -' }}
      .list(v-show="currentIndex == 3 && numberList.length")
        LotteryPublicityCard(
          :numberList="numberList"
        )
        .tips - 仅展示近7日中奖公示 -
      //- 错误提示
      .fail-network(
        v-for="(item, id) in tabList"
        :key="item.code"
        v-if="\
          item.code == currentIndex \
          && (errorFlag || ![userWinningList,records,numberList][id].length) \
        "
      )
        img.pic(:src="errorImg")
        .tip {{ errorFlag ? '请稍后重试': '暂无记录，快去抽奖吧' }}
  CouponLayer(
    v-if="layerVisible"
    :couponGameAB="couponGameAB"
    :vipData="vipData"
    :isLotteryNew="lotteryNewVersion"
    :currentOrderOptType="currentOrderOptType"
    @close="handleCloseCouponLayer"
    @refresh="getCouponRideCardData"
    @refreshLottery="handleRefreshLottery"
  )
</template>

<script>
import { env } from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { Navigator } from '@hb/h5-navigator';
import { InfiniteScroll } from 'mint-ui';
import {
  getLotteryRecord,
  getUsersWinningPrizes,
  getlotteryLeadInfo,
  getWinningAnnouncement,
  getSuperUserPropert,
} from '@/api/vip';
import { getTokenAndLocation } from '@/utils';
import { PropVersionMap } from '@/const/vip';
import { getVersion, getSystemCode } from '@/utils/systemCode';
import CommonHeader from '@/components/common-middle-header.vue';
import CouponLayer from './components/new-member/coupon-layer.vue';
import SuperCard from './components/super-card';
import LotteryMarquee from './components/lottery-marquee';
import ErrorPage from './components/errorPage';
import LotteryRecordHeader from './components/lottery-record-header.vue';
import LotteryPublicityCard from './components/lottery-publicity-card';
import { LOTTERY_RECORD_TAB_LIST } from '../consts';

export default {
  directives: {
    InfiniteScroll,
  },
  components: {
    SuperCard,
    CommonHeader,
    ErrorPage,
    LotteryMarquee,
    LotteryRecordHeader,
    LotteryPublicityCard,
    CouponLayer,
  },
  props: {},
  data() {
    return {
      env,
      loading: false,
      more: true,
      currentIndex: 1,
      pageIndex: 1,
      pageSize: 10,
      records: [],
      numberList: [],
      userWinningList: [],
      marqueeList: [],
      errorImg: 'https://m.hellobike.com/resource/gallery/407/iUOp9M3ZoI.png?x-oss-process=image/quality,q_80',
      tabList: LOTTERY_RECORD_TAB_LIST,
      last: 0,
      errorFlag: false,
      // 是否吸顶状态
      isTabSticky: false,
      // tab吸顶位置
      tabTopValue: '0',
      // 概率模块元素
      probabilityInfoEl: null,
      // 概率模块是否吸顶
      isProbSticky: false,
      // 是否展示优惠券浮层
      layerVisible: false,
      propVersion: '',
      couponGameAB: '',
      // 卡券数据未处理
      vipData: {},
    };
  },
  computed: {
    lotteryNewVersion() {
      if (!this.vipData || !this.vipData.propVersion) {
        return false;
      }
      let showLottery = false;
      const { propVersion } = this.vipData;
      if (propVersion) {
        showLottery = ![PropVersionMap.NORMAL].includes(propVersion);
      }
      return showLottery;
    },
  },
  provide() {
    return {
      getPropVersion: () => this.propVersion,
      freeRightsVersion: () => this.propVersion === PropVersionMap.RIDE_STEADY_VERSION
        || this.propVersion === PropVersionMap.RIDE_RADICAL_VERSION,
    };
  },
  mounted() {
    let { tab, batchNo } = this.$route.query;
    const { currentOrderOptType } = this.$route.query;
    if (!tab) {
      tab = 1;
    }
    batchNo = batchNo || '';
    this.currentOrderOptType = currentOrderOptType !== undefined
      ? Number(currentOrderOptType)
      : null;
    this.getlotteryLeadInfoList(batchNo);
    this.tabClick({ code: tab });
    // this.getCouponRideCardData();

    // 初始化滚动监听
    window.addEventListener('scroll', this.handlePageScroll);
    // 页面曝光埋点
    UBT.pageView({
      pageId: 'platform_ririchou',
      categoryId: 'platform',
      businessInfo: {},
    });
    // 初始化tab曝光埋点
    this.handleTabExpo();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handlePageScroll);
    // 离开页面埋点
    UBT.pageViewOut({
      pageId: 'platform_ririchou',
      categoryId: 'platform',
      businessInfo: {},
    });
  },
  methods: {
    tabClick(item) {
      const { code, spm } = item || {};
      // 点击tab埋点
      if (spm) {
        UBT.clickButton({
          pageId: 'platform_ririchou',
          buttonName: spm,
          categoryId: 'platform',
          businessInfo: {},
        });
      }

      this.currentIndex = Number(code);
      if (this.currentIndex === 1) {
        this.errorFlag = false;
        this.getWinningList();
      } else if (this.currentIndex === 2) {
        this.errorFlag = false;
        if (this.records.length) {
          return;
        }
        this.load();
      } else if (this.currentIndex === 3) {
        this.errorFlag = false;
        this.getWinningAnnouncementList();
      }
    },
    jumpUrl(data) {
      if (data.prizes && data.prizes[0] && data.prizes[0].targetUrl) {
        Navigator.go(data.prizes[0].targetUrl);
      }
      // else if (data.prizes && data.prizes[0] && data.prizes[0].prizeType === 5) {
      //   Navigator.go(`https://m.hellobike.com/AppPlatformH5/${config.env !== 'pro' ? `${config.env}/` : ''
      //   }latest/index.html#/bounty`);
      // }
    },
    async getWinningAnnouncementList() {
      if (this.numberList.length) {
        return;
      }
      let { campaignCode } = this;
      if (!campaignCode) {
        campaignCode = this.$route.query.campaignCode || '';
        this.campaignCode = campaignCode;
      }
      const data = await getTokenAndLocation();
      const {
        token, adCode, cityCode,
      } = data;
      getWinningAnnouncement({
        token,
        adCode,
        cityCode,
        campaignCode,
        systemCode: getSystemCode(),
        version: await getVersion(),
      }).then((res) => {
        if (res.data) {
          this.numberList = res.data.winningAnnouncementDTOS;
        }
      }).catch(() => {
        this.errorFlag = true;
      });
    },
    async getlotteryLeadInfoList(batchNo) {
      let { campaignCode } = this;
      if (!campaignCode) {
        campaignCode = this.$route.query.campaignCode || '';
        this.campaignCode = campaignCode;
      }
      const data = await getTokenAndLocation();
      const {
        token, adCode, cityCode,
      } = data;
      getlotteryLeadInfo({
        token,
        adCode,
        cityCode,
        campaignCode,
        batchNo,
        systemCode: getSystemCode(),
        version: await getVersion(),
      }).then((res) => {
        if (res.data) {
          this.marqueeList = res.data.lotteryLeadDTOS;
        }
      });
    },
    async getWinningList() {
      if (this.userWinningList.length) {
        return;
      }
      let { campaignCode } = this;
      if (!campaignCode) {
        campaignCode = this.$route.query.campaignCode || '';
        this.campaignCode = campaignCode;
      }
      const data = await getTokenAndLocation();
      const {
        token, adCode, cityCode,
      } = data;
      getUsersWinningPrizes(
        {
          token,
          adCode,
          cityCode,
          campaignCode,
          systemCode: getSystemCode(),
          version: await getVersion(),
        },
      ).then((res) => {
        if (res.data) {
          this.userWinningList = res.data.prizes;
        }
      }).catch(() => {
        this.errorFlag = true;
      });
    },
    async load() {
      if (this.currentIndex !== 2) {
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      if (!this.more) {
        return;
      }
      const now = new Date().getTime();
      if (now - this.last < 500) {
        return;
      }
      let { campaignCode } = this;
      if (!campaignCode) {
        campaignCode = this.$route.query.campaignCode || '';
        this.campaignCode = campaignCode;
      }
      this.last = now;
      const data = await getTokenAndLocation();
      const {
        token, adCode, cityCode,
      } = data;
      getLotteryRecord({
        token,
        adCode,
        cityCode,
        campaignCode,
        systemCode: getSystemCode(),
        version: await getVersion(),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then((res) => {
        this.loading = false;
        if (res.data && res.data.data) {
          this.records = this.records.concat(res.data.data);
          if (res.data.recordsCounts <= this.records.length) {
            this.more = false;
          }
        } else {
          this.more = false;
        }
      }).catch(() => {
        this.errorFlag = true;
        this.loading = false;
      });
      this.pageIndex += 1;
    },
    normalWinningData(data) {
      return {
        batchNo: data.receiveAwardTime || '',
        prizeStatus: false,
        prizeType: data.prizeType,
        worth: data.worth,
        prizes: [
          {
            prizeName: data.prizeName || '',
            prizeCode: data.prizeCode || '',
            icon: data.icon || '',
            targetUrl: data.targetUrl || '',
          },
        ],
      };
    },
    normalData(data) {
      return {
        batchNo: data.batchNo || '',
        prizeStatus: data.prizeStatus || false,
        prizes: [
          {
            prizeCode: data.prizes && data.prizes.length ? data.prizes[0].prizeCode : '',
            prizeName: data.prizes && data.prizes.length ? data.prizes[0].prizeName : '',
            icon: data.prizes && data.prizes.length ? data.prizes[0].icon : '',
            targetUrl: data.prizes && data.prizes.length ? data.prizes[0].targetUrl : '',
          },
        ],
      };
    },
    // 页面滚动监听
    handlePageScroll() {
      const { recordTabRef } = this.$refs || {};
      const { pageYOffset: scrollTop } = window;

      // 获取概率模块元素
      if (!this.probabilityInfoEl) {
        const probabilityInfoEl = document.getElementById('probability-info');
        this.probabilityInfoEl = probabilityInfoEl;
      }
      const { offsetHeight = 0, offsetTop = 0 } = this.probabilityInfoEl || {};
      // 概率模块吸顶位置判断
      if (offsetTop) {
        this.isProbSticky = (scrollTop - 4) > offsetTop;
      }

      if (!recordTabRef) return;
      const { offsetTop: tabOffsetTop } = recordTabRef;
      // 根据环境做吸顶位置计算
      if (env.isEasyBikeApp) {
        this.tabTopValue = offsetHeight ? '1.25rem' : '0.84rem';
      } else {
        this.tabTopValue = offsetHeight ? '0.43rem' : '-0.01rem';
      }
      // tab吸顶位置判断
      this.isTabSticky = (scrollTop + offsetHeight - 4) > tabOffsetTop;
    },
    // tab曝光埋点
    handleTabExpo() {
      this.tabList.forEach((item) => {
        UBT.moduleExpose({
          pageId: 'platform_ririchou',
          categoryId: 'platform',
          moduleId: item.spm,
          contentId: item.spm,
          exposureTimes: 1,
          businessInfo: {},
        });
      });
    },
    // 获取卡券数据
    async getCouponRideCardData() {
      const { token, cityCode, adCode } = await getTokenAndLocation();
      try {
        const res = await getSuperUserPropert({
          token,
          cityCode,
          adCode,
          systemCode: getSystemCode(),
          goodsType: '1',
          pageCode: 'newOpen',
        });
        if (res && res.data) {
          this.vipData = res.data;
          this.propVersion = res.data.propVersion || '';
          this.couponGameAB = res.data.couponGameAB || '';
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
    // 显示优惠券浮层
    async handleShowCouponLayer() {
      try {
        await this.getCouponRideCardData();
        this.layerVisible = true;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('获取卡券数据失败:', e);
      }
    },
    // 关闭优惠券浮层
    handleCloseCouponLayer() {
      this.layerVisible = false;
    },
    // 刷新抽奖活动数据
    handleRefreshLottery() {
      if (this.$refs.recordHeaderRef) {
        this.$refs.recordHeaderRef.getLotteryActivityInfo();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.lottery-record-container {
  position: relative;
  padding-top: 0.88rem;
  width: 100vw;
  min-height: 100vh;
  background-color: #f0f3f5;
  box-sizing: border-box;

  .lottery-record-header-bg {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 1.55rem;
    background:
      linear-gradient(
        104.05deg,
        #fffaf0 8.32%,
        #fff1d4 34.67%,
        #fff1d4 65.67%,
        #ffe8b8 90.65%
      );

    .bg-logo {
      position: absolute;
      right: 0;
      bottom: 0.1rem;
      width: 0.95rem;
      height: 0.95rem;
    }

    &.not-app-bg {
      height: 4.89rem;
      background:
        linear-gradient(
          0deg,
          #f3f4f6 2.15%,
          #ffe0bc 21.72%,
          #ffe4ba 88.7%,
          #ffe59c 100%
        );

      .bg-logo {
        top: 0;
        right: 0;
      }
    }
  }

  .lottery-record-content {
    position: relative;
    z-index: 1;
  }

  .header-left-area {
    display: flex;
    align-items: center;

    .title-logo {
      width: auto;
      height: 0.166rem;
      vertical-align: bottom;
    }

    .desc-logo {
      margin-left: 0.11rem;
      width: auto;
      height: 0.14rem;
      vertical-align: bottom;
    }
  }

  .record-tab-container {
    width: 100%;
    height: 0.5rem;
    margin-bottom: -0.01rem;
  }

  .record-tab {
    display: flex;
    justify-content: space-between;
    padding: 0.16rem 0.45rem 0;
    width: 100%;
    height: 0.5rem;
    background-image:
      linear-gradient(
        178.54deg,
        #fff6d6 -7.54%,
        #f4f5f0 16.16%,
        #f0f3f5 98.76%
      );
    border-radius: 0.2rem 0.2rem 0 0;
    border-top: 2px solid #fff;
    transition: all 0.3s ease;

    &.tab-sticky {
      position: fixed;
      top: 0.84rem;
      left: 0;
      right: 0;
      z-index: 99;
      background-color: #fff;
      background-image: none;
      border-radius: 0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .tab-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #000;
      height: auto;
      line-height: 0.22rem;

      .name {
        font-size: 0.16rem;
        opacity: 0.5;

        &.actived {
          font-weight: 500;
          opacity: 1;
        }
      }

      .line {
        margin-top: 0.03rem;
        width: 0.19rem;
        height: 0.02rem;
        background-color: #000;
        border-radius: 0.02rem;
      }
    }
  }

  .list-page {
    width: 100%;
    min-height: 50vh;
    background-color: rgba(243, 244, 246, 1);
    padding: 0.11rem 0.12rem 0.2rem;

    .no-data {
      width: 2.55rem;
      height: 1.85rem;
      background-image: url(https://m.hellobike.com/resource/gallery/350/SZocaAKZ_no-data.png);
      background-repeat: no-repeat;
      background-size: 100%;
      margin: 1.78rem auto 0;
    }

    .fail-network {
      padding: 1rem 0 1.4rem;
      width: 100%;
      height: 100%;
      background: #f3f4f6;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      flex-direction: column;

      .pic {
        height: 1rem;
      }

      .tip {
        margin-top: 0.16rem;
        font-size: 0.14rem;
        font-weight: 400;
        color: #242729;
      }
    }

    .list {
      width: 100%;

      .item {
        margin-bottom: 0.09rem;
      }

      .tag {
        padding: 0.31rem 0 0.2rem;
        font-weight: 500;
        font-size: 0.12rem;
        color: #000;
        opacity: 0.5;
        text-align: center;
      }

      .tips {
        display: flex;
        justify-content: center;
        padding: 0.4rem 0 0.2rem;
        font-weight: 500;
        font-size: 0.12rem;
        line-height: 0.17rem;
        color: #000;
        opacity: 0.5;
      }

      .bottom-line {
        width: 100%;
        height: 0.26rem;
      }
    }
  }
}
</style>
